import { FontType, TextAlign } from '@modusign/react-signing/types';

import { AbsoluteSize } from '@app/features/apply-react-signing/components/FieldRenderer/types';
import AddressFieldPlaceholder from '@app/features/apply-react-signing/components/FieldSetupStep/Placeholders/AddressFieldPlaceholder';
import { useTransformTextStyle } from '@app/features/apply-react-signing/libs/hooks/useTransFormTextStyle';
import PDFFontNormalizer from '@app/libs/reactPdfJs/utils/PDFFontNormalizer';

interface AddressFieldMousePlaceholderProps {
  size: AbsoluteSize;
  fontFamily: FontType;
  fontSize: number;
  required: boolean;
  textAlign: TextAlign;
  participantOrder: number;
  scale: number;
}

const defaultProps = {
  latestFieldData: null,
  participantOrder: 1,
  scale: 1,
};

function AddressFieldMousePlaceholder({
  size,
  fontFamily,
  fontSize,
  required,
  textAlign,
  participantOrder,
  scale,
}: AddressFieldMousePlaceholderProps) {
  const fontPixelSize = PDFFontNormalizer.toPixelFontSize({ fontSize }, scale);
  const { transformTextStyle } = useTransformTextStyle({
    size,
    fontFamily,
    fontSize,
    textAlign,
    scale,
  });

  return (
    <AddressFieldPlaceholder
      fontPixelSize={fontPixelSize}
      participantOrder={participantOrder}
      rootElementSize={size}
      star={required}
      style={transformTextStyle}
    />
  );
}

AddressFieldMousePlaceholder.defaultProps = defaultProps;

export default AddressFieldMousePlaceholder;
